import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { HttpStatus, INITIAL_PAGINATION } from "../../../common/Constants";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { getHistoryTableConfig } from "./config";

class InventoryPartDetailHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataDetail: null,
      pagination: INITIAL_PAGINATION,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { onTriggerLoading, setError, barcode } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getBarcodeHistoryInventoryPart,
      menuName: "Inventory Part",
      setError: setError,
      args: {
        barcode: barcode,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataDetail: res.data.data,
      });
    }
  };

  getTableColumn = () => {
    return getHistoryTableConfig();
  };

  render() {
    const { onClickClose, visible, selectedData } = this.props;
    const { dataDetail, pagination } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Riwayat Flow Part"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_kode_part"
                    name="partCode"
                    label="Kode Part"
                    readOnly
                    value={dataDetail?.partCode}
                  />
                  <SimpleInput
                    id="input_text_nama_part"
                    name="partName"
                    label="Nama Part"
                    readOnly
                    value={dataDetail?.partName}
                  />
                </div>
                <div id="grid-2">
                  <SimpleInput
                    id="input_text_kategori_part"
                    name="category"
                    label="Kategori Part"
                    readOnly
                    value={selectedData?.category}
                  />
                </div>
              </div>
              <SimpleDataTable
                data={dataDetail?.history || []}
                columns={this.getTableColumn()}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={{ serverSide: false }}
              />
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartDetailHistory;
